import React, { useState } from "react";
import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface PublishPresentationDraftDialogProps {
	readonly open: boolean;
	readonly isSubmitting: boolean;
	readonly talentName: string;
	readonly onClose: () => void;
	readonly onConfirm: (isExemplary: boolean) => void;
}

const PublishPresentationDraftDialog: React.FC<PublishPresentationDraftDialogProps> = ({
	open,
	isSubmitting,
	talentName,
	onClose,
	onConfirm
}) => {
	const { t } = useTranslation();
	const [isExemplary, setIsExemplary] = useState(false);

	return (
		<Dialog open={open} onClose={isSubmitting ? undefined : onClose} fullWidth maxWidth="sm">
			<DialogTitle>{t("presentationDraft.publish.title")}</DialogTitle>
			<DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
				<DialogContentText>{t("presentationDraft.publish.message", { name: talentName })}</DialogContentText>
				<FormControlLabel
					control={
						<Checkbox
							checked={isExemplary}
							onChange={event => setIsExemplary(event.target.checked)}
							color="secondary"
						/>
					}
					label={t("presentationDraft.publish.exemplary")}
				/>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2.5 }}>
				<Button onClick={onClose} disabled={isSubmitting}>
					{t("common.cancel")}
				</Button>
				<Button variant="contained" color="secondary" onClick={() => onConfirm(isExemplary)} disabled={isSubmitting}>
					{t("presentationDraft.publish.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PublishPresentationDraftDialog;
